import DropDownButtonList from '@/components/ui/DropDownButtonList';
import ConfirmDialog from '@/components/ui/ConfirmDialog';
import { assign } from 'lodash';

export default {
  components: { ConfirmDialog, DropDownButtonList },

  data() {
    return {
      storeActionListRequest: null,
      storeActionRemove: null,
      storeActionDownload: null,
      uploadModalId: 'upload-modal',
      uploadRefName: 'uploadModal',
      dropdownId: 'dropdown-items',
      deleteModalId: 'delete-confirm-dialog',
      itemIdToRemove: null,
      sort: {
        field: 'id',
        type: 'desc',
      },
      totalRecords: 0,
      page: 1,
      perPage: 20,
      pageSize: [10, 20, 30, 50, 100],
      totalPage: 1,
      filter: null,
      footerAmount: '',
    };
  },

  methods: {
    async onUpload() {
      await this.$refs[this.uploadRefName].resetForm();
      await cash(`#${this.uploadModalId}`).modal('show');
      cash(`#${this.dropdownId}`).dropdown('hide');
    },

    confirmRemoval(id) {
      this.itemIdToRemove = id;
      cash(`#${this.deleteModalId}`).modal('show');
    },

    async onDelete() {
      cash(`#${this.deleteModalId}`).modal('hide');
      try {
        await this.$store.dispatch(this.storeActionRemove, this.itemIdToRemove);
      } catch (error) {
        this.$toasted.show(error.message, { type: 'error' });
      }
      this.itemIdToRemove = null;
    },

    onSortChange(params) {
      this.sort = params;
      this.onPageChange(1);
    },

    onPerPageChange(perPage) {
      this.perPage = perPage;
      this.onPageChange(1);
    },

    onPageChange(page) {
      this.page = page;
      this.fetchData();
    },

    onFilter(payload) {
      this.filter = payload;
      this.fetchData();
    },

    async onDownload() {
      const payload = {
        filters: {},
      };

      if (this.sort) {
        assign(payload, { sort: this.sort });
      }

      await this.setFilterValues(payload);

      if (this.filter && this.filter.field) {
        payload.filters[`filter[${this.filter.field}]`] = this.filter.value;
      }

      await this.$store.dispatch(this.storeActionDownload, payload);
      this.setDownloads();
    },

    async fetchData() {
      const payload = {
        filters: {},
        page: this.page,
        perPage: this.perPage,
      };

      if (this.sort) {
        assign(payload, { sort: this.sort });
      }

      await this.setFilterValues(payload);

      if (this.filter && this.filter.field) {
        payload.filters[`filter[${this.filter.field}]`] = this.filter.value;
      }

      await this.$store.dispatch(this.storeActionListRequest, payload);
      await this.setPaginationValues();
    },

    setFilterValues() {},

    setPaginationValues() {},

    setDownloads() {},
  },
};
